export const Messages = {
    NO_CUSTOMERS: "Nemate nijednog kupca. Kontaktirajte nadležnu osobu.",
    NO_ORDERS: "Niste napravili ni jednu porudžbinu. Dodajte porudžbinu tako sto će te pritisnuti na +",
    CHANGES_SAVED: "Izmene su uspešno sačuvane.",
    NO_ARTICLES_ADDED_FOR_CUSTOMER: "Morate dodati bar jedan artikal pre nego što nastavite dalje.",
    NO_PRODUCTS_ORDERED: "Molimo Vas da odaberete bar jedan proizvod pre nego što izvršite porudžbinu.",
    NO_DELIVERY_DATE: "Molimo Vas da odaberete datum isporuke",
    SUCCESS_ORDER: "Porudžbina je uspešno sačuvana.",
    SUCCESS_ORDER_MODIFIED: "Porudžbina je uspešno izmenjena.",
    SUCCESS_CUSTOMER: "Novi kupac je uspešno sačuvan.",
    VENDOR_EMAIL_DOES_NOT_EXIST: "Navedeni email ne postoji u bazi",
    RBAC_NO_ACCESS: "Nije Vam odobren pristup aplikaciji, kontaktirajte nadleznu osobu.",
    ALREADY_REGISTERED: "Već ste registrovani",
    USER_DOSE_NOT_EXIST: "Korisnik ne postoji, molimo vas da se registrujete",
    INVALID_SMS_CODE: "SMS kod mora da ima 6 karaktera.",
    REGISTERED_SUCCESSFULY: "Uspešno ste se registrovali.",
    CHECK_CUSTOMER_PHONENUMBER: "Proverite da li je unet broj telefona ispravan.",
    REQUIRED_FIELD: "Obavezno polje",
    CODE_MAX_LENGTH: "Polje ne može da sadrži više od 6 karaktera",
    PIB_MAX_LENGTH: "Polje mora da sadrži 9 karaktera",
    MB_MAX_LENGTH: "Polje mora da sadrži 8 karaktera",
    INVALID_PHONENUMBER_FORMAT: "Molimo Vas unesite ispravan broj telefona",
    INVALID_EMAIL_FORMAT: "Molimo Vas unesite ispravan email",
    ARTICLES_SEARCH_EMPTY: "Nema proizvoda koji odgovaraju vašoj pretrazi: ",
    CUSTOMERS_SEARCH_EMPTY: "Nema kupaca koji odgovaraju vašoj pretrazi: ",
    CONTACT_YOUR_VENDOR: "Kontaktirajte vašeg poslodavca.",
    WITHDRAW_FROM_THE_ORGANIZATION_SUCCESSFULL: "Uspešno ste istupili iz organizacije.",
    ORGANIZATION_IS_NOT_REGISTERED: "Vaša organizacija nije registrovana, molimo Vas posetite http://mdistribution.mprocesses.com i registrujte svoj nalog ili kontaktirajte Vašeg poslodavca",
    CANCEL_PRICE_CHANGE: "Da li ste sigurni da želite da otkažete promenu cena?"
}